<template>
  <div class="mission d-flex flex-column justify-content-center pt-5">
    <div class="missionstart">
      <img src="../assets/images/pic_elf_01.png" alt="">
    </div>
    <div class="d-flex justify-content-center flex-column mx-auto text mt-3">
      <div class="text_content">
        <h5 class="mb-3">你來的正好，我需要參加魔法球考驗，可是有些考驗線索被隱藏了，你可以幫幫我嗎？</h5>
        <h5>1.透過魔法鏡頭讓隱藏線索出現</h5>
        <h5 class="mb-3">2.根據所有線索幫我選出正確的魔法球。</h5>
        <h5 >準備好了，那我們出發吧！</h5>
      </div>
    </div>
    <div class="d-flex justify-content-center mt-5 mb-5">
      <a href="" class="btn">任務開始</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MissionExplanation',
  data () {
    return {
    }
  }
}
</script>
<style lang="scss" scoped>
  .mission {
    margin: auto;
    .missionstart {
      margin: auto;
      width: 200px;
      height: 200px;
      img {
      object-fit: contain;
      height: 100%;
      width: 100%;
      }
    }
  .text {
    color: #1351a4;
    font-weight: 900;
    font-family: '微軟正黑體';
    .text_content {
      max-width: 500px;
      h5 {
        font-weight: 600;
      }
    }
  }

  .btn {
    display: block;
    padding: 10px 30px;
    border-radius: 5px;
    color: white;
    font-weight: bold;
    }
  }
  h5 {
    text-align: left;
  }
</style>
